import FormState, { FieldDescriptors } from "@shopify/react-form-state";
import { Question, QuestionTemplate, QuestionType } from "@teams/types";
import { SurveyDTO } from "@teams/types/api";
import React from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import { AuthoringFields } from "../types";
import { QuestionCard } from "./QuestionCard";

type Props = {
  fields: FieldDescriptors<AuthoringFields>;
  questionTemplates: QuestionTemplate[];
  compressed?: boolean;
  isEdit?: boolean;
  isLimitedEdit?: boolean;
  highlightLastQuestion: boolean;
  parentSurvey?: Pick<SurveyDTO, "questions">;
  collapsedQuestions: { id: string; collapsed: boolean | undefined }[];
  addQuestion: (
    fields: FieldDescriptors<AuthoringFields>,
    question: Question<QuestionType>
  ) => void;
  setCollapsedForQuestion: (
    questionId: string,
    collapsed: boolean,
    fields: FieldDescriptors<AuthoringFields>
  ) => void;
  expandAllQuestions: () => void;
  isMeetingSidePanel?: boolean;
};

export const QuestionCardList: React.FC<Props> = ({
  fields,
  questionTemplates,
  compressed,
  isEdit,
  isLimitedEdit,
  parentSurvey,
  highlightLastQuestion,
  collapsedQuestions,
  addQuestion,
  setCollapsedForQuestion,
  expandAllQuestions,
  isMeetingSidePanel,
}) => {
  return (
    <DndProvider backend={HTML5Backend} context={window}>
      <FormState.List field={fields.questions} getChildKey={item => item.id}>
        {(question, index) => (
          <QuestionCard
            index={index}
            fields={fields}
            questionField={question}
            compressed={compressed}
            isEdit={isEdit}
            isLimitedEdit={isLimitedEdit}
            questionTemplates={questionTemplates}
            originalQuestion={parentSurvey?.questions.find(q => q.id === question.id.value)}
            showHighLight={highlightLastQuestion && index === fields.questions.value.length - 1}
            addQuestion={addQuestion}
            collapsed={collapsedQuestions.find(x => x.id === question.id.value)?.collapsed}
            setCollapsedForQuestion={setCollapsedForQuestion}
            expandAllQuestions={expandAllQuestions}
            isMeetingSidePanel={isMeetingSidePanel}
          />
        )}
      </FormState.List>
    </DndProvider>
  );
};
